import React, { Component, Fragment } from 'react';
import BiodataMenu from "./BiodataMenu";
import { id_camaba } from '../../config/utils';
import { API_ASTOR, API_MHS_KRS } from '../../services/key/api';
import { KEY_ASTOR, KEY_MHS_KRS } from '../../services/key/api_key';
import { optionKebutuhan_1, optionKebutuhan_2 } from './bioAsset/stateBox';
import imageCompression from 'browser-image-compression';
import swal from 'sweetalert';
import { Link } from "react-router-dom";
import $ from 'jquery';
import formatPhone from '../../config/atoms/FormatPhone';


class Biodata extends Component {

    state = {
        formdata: {
            provinsi: '',
            kab: '',
            berkas: {
                ktp: '',
                kk: '',
                ijazah: '',
                ijazah_transfer: '',
                transkrip: '',
                skp: '',
            }
        },
        // dropdown 
        provinsiList: [],
        kotaList: [],
        kecamatanList: [],
        statusMhs: [],
        statusKelas: [],
        jalur: [],
        kategoriKelas: [],
        jalurTransfer: [],
        konsentrasi: [],
        agama: [],
        statusNikah: [],
        jenisTinggal: [],
        transportasi: [],
        pendidikan: [],
        pekerjaan: [],
        penghasilan: [],
        jurusan: [],
        jenjang_pendidikan: [],
        foto: '',
        linkFoto: `${process.env.REACT_APP_API_MHS_KRS}image/`,
        isLoad: false,
        isLoad2: false,
        isWNA: false,
        isLoadingBiodata: true
    }

    getProvinsi = () => {
        API_ASTOR.get("set/wilayah/view" + KEY_ASTOR, {
        }).then((res) => {
            this.setState({
                provinsiList: res.data[0].prof
            })
        });
    }

    getKota = (type) => {
        API_ASTOR.get("set/wilayah/kota/view" + KEY_ASTOR + "&ic=" + this.state.formdata.provinsi, {
        }).then((res) => {
            this.setState({
                kotaList: res.data[0].kota
            }, () => {
                if ((this.state.formdata.kab !== '' || this.state.formdata.kab != null) && type !== "isKota") {
                    this.getKecamatan(this.state.formdata.kab)
                } else {
                    this.setState({ kecamatanList: [] })
                }
            })
        });
    }

    getKecamatan = (val) => {
        if (this.state.kotaList.length !== 0) {
            var data = this.state.kotaList
            var result = data.filter(function (indeks) {
                return indeks.cname === val
            })
            this.setState({
                id_kota: result.length !== 0 ? result[0].ic : null
            }, () => {
                API_ASTOR.get("set/wilayah/kecamatan/view" + KEY_ASTOR + '&ic=' + this.state.id_kota).then((res) => {
                    this.setState({
                        kecamatanList: res.data[0].kecamatan
                    })
                })
            })
        }
    }

    getBiodata = () => {
        API_MHS_KRS.get('core-mhs/biodata/mhs/' + id_camaba + KEY_MHS_KRS).then((res) => {
            this.setState({
                formdata: {
                    ...res.data.content
                },
                statusMhs: res.data.dropdown.statusmhs,
                statusKelas: res.data.dropdown.statuskelas,
                jalur: res.data.dropdown.jalur,
                kategoriKelas: res.data.dropdown.kategori_kelas,
                jalurTransfer: res.data.dropdown.jalur_transfer,
                konsentrasi: res.data.dropdown.konsentrasi,
                agama: res.data.dropdown.agama,
                statusNikah: res.data.dropdown.status_nikah,
                jenisTinggal: res.data.dropdown.jenis_tinggal,
                transportasi: res.data.dropdown.transportasi,
                pendidikan: res.data.dropdown.pendidikan,
                pekerjaan: res.data.dropdown.pekerjaan,
                penghasilan: res.data.dropdown.penghasilan,
                jurusan: res.data.dropdown.jurusan,
                jenjang_pendidikan: res.data.dropdown.jenjangpendidikan_asal
            }, () => {
                this.state.formdata.kebutuhan_khusus_mhs.map((list) => {
                    return $(".kebutuhanMhs input[type=checkbox][value='" + list + "']").prop('checked', true)
                })
                this.state.formdata.kebutuhan_khusus_ayah.map((list) => {
                    return $(".kebutuhanAyah input[type=checkbox][value='" + list + "']").prop('checked', true)
                })
                this.state.formdata.kebutuhan_khusus_ibu.map((list) => {
                    return $(".kebutuhanIbu input[type=checkbox][value='" + list + "']").prop('checked', true)
                })
                if (this.state.formdata.provinsi !== '') { this.getKota() }
                if (this.state.formdata.kewarganegaraan === "WNA") { this.setState({ isWNA: true }) }
                localStorage.setItem('nama', this.state.formdata.nama)
                localStorage.setItem('foto', this.state.formdata.foto_mhs)
                this.setState({ isLoadingBiodata: false })
            })
        })
    }

    onChangeInput = (e) => {
        this.setState({
            formdata: {
                ...this.state.formdata,
                [e.target.name]: e.target.value
            }
        })
    }

    onChangeProv = (e) => {
        this.setState({
            formdata: {
                ...this.state.formdata,
                [e.target.name]: e.target.value
            }
        }, () => {
            if (this.state.formdata.provinsi !== '') {
                this.getKota("isKota")
            }
        })
    }

    onChangeKota = (e) => {
        this.setState({
            formdata: {
                ...this.state.formdata,
                kab: e.target.value
            }
        }, () => {
            this.getKecamatan(this.state.formdata.kab)
        })
    }

    onChangeJenisTF = (e) => {
        this.setState({
            formdata: {
                ...this.state.formdata,
                [e.target.name]: e.target.value
            }
        }, () => {
            if (this.state.formdata.perguruan_tinggi_tf === 1) {
                this.setState({
                    formdata: {
                        ...this.state.formdata,
                        jurusan_asal_tf: '',
                        nama_perguruan_tinggi_asal: ''
                    }
                })
            }
        })
    }


    onChangeKhusus = (e) => {
        if (e.target.checked) {
            if (e.target.name === 'keb_ayah') {
                var data = this.state.formdata.kebutuhan_khusus_ayah.filter(x => x === e.target.value)
                if (data.length === 0) {
                    this.state.formdata.kebutuhan_khusus_ayah.push(e.target.value)
                }
            } else if (e.target.name === 'keb_ibu') {
                var data1 = this.state.formdata.kebutuhan_khusus_ibu.filter(x => x === e.target.value)
                if (data1.length === 0) {
                    this.state.formdata.kebutuhan_khusus_ibu.push(e.target.value)
                }
            } else if (e.target.name === 'keb_mhs') {
                var data2 = this.state.formdata.kebutuhan_khusus_mhs.filter(x => x === e.target.value)
                if (data2.length === 0) {
                    this.state.formdata.kebutuhan_khusus_mhs.push(e.target.value)
                }
            }
        } else {
            if (e.target.name === 'keb_ayah') {
                var index = this.state.formdata.kebutuhan_khusus_ayah.indexOf(e.target.value);
                this.state.formdata.kebutuhan_khusus_ayah.splice(index, 1);
            } else if (e.target.name === 'keb_ibu') {
                var index1 = this.state.formdata.kebutuhan_khusus_ibu.indexOf(e.target.value);
                this.state.formdata.kebutuhan_khusus_ibu.splice(index1, 1);
            } else if (e.target.name === 'keb_mhs') {
                var index2 = this.state.formdata.kebutuhan_khusus_mhs.indexOf(e.target.value);
                this.state.formdata.kebutuhan_khusus_mhs.splice(index2, 1);
            }
        }
    }

    onChangeFoto = async (event) => {
        if (event.target.value.length !== 0) {
            this.setState({ isLoad: true })
            let fotoProfil = event.target.files[0];
            let fileFoto = document.getElementById('upload-photo');
            const options = {
                maxSizeMB: 0.25,
                maxWidthOrHeight: 1280,
                useWebWorker: true
            };
            if (/(\.jpg|\.jpeg|\.png)$/i.test(fileFoto.files[0].name) === false) {
                document.getElementById('upload-photo').value = '';
                document.getElementById('foto').src = '';
                swal({
                    icon: 'info',
                    title: 'Upload Gambar',
                    text: 'File harus berformat gambar'
                });
                return false;
            } else {
                const compressedFile = await imageCompression(fotoProfil, options);
                if (compressedFile !== null || compressedFile !== '') {
                    document.getElementById('foto').src = URL.createObjectURL(compressedFile);
                } else {
                    this.setState({ isLoad: false })
                    document.getElementById('foto').src = URL.createObjectURL(this.state.linkFoto + this.state.formdata.foto_mhs);
                }
                this.setState({
                    foto: compressedFile
                }, () => {
                    const formData = new FormData();
                    formData.append(
                        "foto",
                        this.state.foto,
                        this.state.foto.name
                    );
                    API_MHS_KRS.post('core-upload/mhs/biodata/' + id_camaba + KEY_MHS_KRS, formData, {
                        headers: { "Content-Type": "multipart/form-data" }
                    }).then((res) => {
                        if (res.status === 200) {
                            this.setState({ isLoad: false })
                            this.getBiodata()
                        } else {
                            this.setState({ isLoad: false })
                            swal({
                                icon: 'error',
                                title: 'Gagal Upload Gambar',
                                text: 'Periksa koneksi atau komputer anda!'
                            });
                        }
                    })
                });
            }
        }
    };

    onChangeWarga = (e) => {
        this.setState({
            formdata: {
                ...this.state.formdata,
                kewarganegaraan: e.target.value
            }
        }, () => {
            if (this.state.formdata.kewarganegaraan === "WNA") {
                this.setState({
                    isWNA: true
                })
            } else {
                this.setState({
                    isWNA: false
                })
            }
        })
    }

    execSubmit = () => {
        API_MHS_KRS.post('core-mhs/biodata/mhs/' + id_camaba + KEY_MHS_KRS, this.state.formdata).then((res) => {
            if (res.status === 200) {
                this.setState({ isLoad2: false })
                swal({
                    icon: 'success',
                    title: 'Update Berhasil',
                    text: 'Data telah diperbaharui!'
                }).then(() => {
                    window.location.reload()
                })
            } else {
                this.setState({ isLoad2: false })
                swal({
                    icon: 'error',
                    title: 'Gagal Update',
                    text: 'Internal Server Error!'
                });
            }
        })
    }

    validateInput = (teks) => {
        const regex = /^[a-zA-Z0-9.' ]+$/
        return regex.test(teks)
    };

    submit = (e) => {
        function alertSwal(teks) {
            return swal({
                icon: 'info',
                title: 'Periksa Form Anda!',
                text: teks
            });
        }
        e.preventDefault()
        if (!this.validateInput(this.state.formdata.nama) || this.state.formdata.nama == "") {
            alertSwal("Nama lengkap tidak boleh kosong, dan harus abjad, tidak boleh simbol")
            return false
        }
        if (!this.state.isWNA && (!this.validateInput(this.state.formdata.nik) || this.state.formdata.nik == "")) {
            alertSwal("NIK tidak boleh kosong, dan harus angka, tidak boleh simbol")
            return false
        }
        if (!this.validateInput(this.state.formdata.nisn) || this.state.formdata.nisn == "") {
            alertSwal("NISN tidak boleh kosong, dan harus angka, tidak boleh simbol")
            return false
        }
        if (!this.validateInput(this.state.formdata.nowa) || this.state.formdata.nowa == "") {
            alertSwal("Nomor WA tidak boleh kosong, dan harus angka, tidak boleh simbol")
            return false
        }
        if (!this.validateInput(this.state.formdata.namaayah) || this.state.formdata.namaayah == "") {
            alertSwal("Nama Ayah tidak boleh kosong, dan harus abjad, tidak boleh simbol")
            return false
        }
        if (!this.validateInput(this.state.formdata.nama_ibu) || this.state.formdata.nama_ibu == "") {
            alertSwal("Nama Ibu tidak boleh kosong, dan harus abjad, tidak boleh simbol")
            return false
        }
        this.setState({ isLoad2: true })
        if (this.state.isWNA) {
            this.setState({
                formdata: {
                    ...this.state.formdata,
                    nik: ''
                }
            }, () => {
                this.execSubmit()
            })
        } else {
            this.setState({
                formdata: {
                    ...this.state.formdata,
                    passport: '',
                    negara: ''
                }
            }, () => {
                this.execSubmit()
            })
        }
    }

    onChangeBerkas = async (e) => {
        this.setState({
            [e.target.name]: e.target.files[0]
        }, () => {
            const formData = new FormData();
            formData.append(
                `${e.target.name}`,
                this.state[e.target.name],
                this.state[e.target.name].name
            );
            document.getElementById('loader-' + e.target.id).classList.remove('sembunyi')
            document.getElementById('berkas-' + e.target.id).classList.add('sembunyi')
            API_MHS_KRS.post('core-upload/mhs/berkas/' + id_camaba + KEY_MHS_KRS, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            }).then((res) => {
                if (res.status == 200) {
                    document.getElementById('loader-' + e.target.id).classList.add('sembunyi')
                    document.getElementById('berkas-' + e.target.id).classList.remove('sembunyi')
                    swal({
                        icon: 'success',
                        title: 'Berhasil Upload',
                        text: 'Berkas telah disimpan'
                    });
                    this.getBiodata()
                }
                else if (res.data.status_code == 404) {
                    document.getElementById('loader-' + e.target.id).classList.add('sembunyi')
                    document.getElementById('berkas-' + e.target.id).classList.remove('sembunyi')
                    swal({
                        icon: 'error',
                        title: 'Gagal Upload',
                        text: 'Transkrip hanya boleh format pdf!'
                    });
                }
                else {
                    document.getElementById('loader-' + e.target.id).classList.add('sembunyi')
                    document.getElementById('berkas-' + e.target.id).classList.remove('sembunyi')
                    swal({
                        icon: 'error',
                        title: 'Gagal Upload',
                        text: 'Periksa koneksi atau komputer anda!'
                    });
                }
            })
        })
    }

    async getDownload(file, nim, type) {
        if (file !== undefined) {
            const id = this.props.match.params.idMhs
            const url = process.env.REACT_APP_API_MHS_KRS + "core-upload/mhs/berkas/" + type + '/' + id_camaba;
            const response = await fetch(url);
            const blob = await response.blob();
            const blobURL = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobURL;
            link.download = nim + "-" + type;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            swal({
                icon: 'info',
                title: 'File Tidak Ditemukan!',
                text: 'Periksa koneksi atau komputer anda atau data memang tidak ada!'
            });
        }
    }

    handleUpload = (type) => {
        document.getElementById(type).classList.toggle("sembunyi")
        document.getElementById('btn-' + type).classList.toggle("sembunyi")
        document.getElementById('toogle-' + type).classList.toggle("sembunyi")
        document.getElementById('toogle2-' + type).classList.toggle("sembunyi")
    }

    componentDidMount = () => {
        $('.openTab').attr('checked', true);
        this.getProvinsi();
        this.getBiodata();
    }

    render() {
        return (
            <Fragment>
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-12 col-xl-8 mb-xl-0">
                            <p className="abu" style={{ fontSize: "15px", fontWeight: "bold", color: "#999999", textTransform: "capitalize" }}>
                                Home&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Biodata Mahasiswa
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-3">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="outer">
                                    <img
                                        src={
                                            this.state.formdata.foto_mhs ?
                                                this.state.linkFoto + this.state.formdata.foto_mhs
                                                : "/no-image.jpg"
                                        }
                                        className="fotoDetail"
                                        id="foto"
                                        alt=""
                                    />
                                    <div className="inner" title="ganti photo">
                                        {
                                            this.state.isLoad ?
                                                <>
                                                    <input
                                                        className="inputfile"
                                                        type="file"
                                                    />
                                                    <label className="fa fa-spinner fa-spin" />
                                                </>
                                                :
                                                <>
                                                    <input
                                                        className="inputfile"
                                                        id="upload-photo"
                                                        type="file"
                                                        accept="image/*"
                                                        name="foto"
                                                        onChange={this.onChangeFoto}
                                                    />
                                                    <label className="ti-camera" />
                                                </>
                                        }
                                    </div>
                                </div>
                            </div>
                            {/* {
                                this.state.isLoad2 ?
                                    <button className="btn btn-primary btn80 btnRounded30 mt-4 tengah" disabled>
                                        updating data.. &nbsp;&nbsp;<i className="fa fa-spinner fa-spin" />
                                    </button>
                                    :
                                    <button className="btn btn-primary btn80 btnRounded30 mt-4 tengah" onClick={this.submit}>
                                        <i className="fa fa-save" />
                                        &nbsp;&nbsp;update data
                                    </button>
                            } */}
                            <Link className="btn btn-success btn80 btnRounded30 mt-2 tengah"
                                to={{
                                    pathname: `/printBiodata`,
                                    state: {
                                        dataPrint: this.state.formdata,
                                        provinsi: this.state.provinsiList,
                                        linkFoto: this.state.linkFoto
                                    }
                                }}
                            >
                                <i className="fa fa-print" />
                                &nbsp;&nbsp;cetak .pdf
                            </Link>
                            <BiodataMenu />
                        </div>
                    </div>
                    <div className="col-xl-9">
                        {/* tab biodata  */}
                        <div className="tabsCon" id="tab1box">
                            <div className="TapS2">
                                <div className="tapbs2">
                                    <input type="checkbox" id="chck3" className="checkBox2 openTab" />
                                    <label className="tapbs-label2" htmlFor="chck3">Profil Mahasiswa</label>
                                    <div className="tapbs-content2">
                                        <div className="row" style={{ padding: '10px 23px 10px 23px' }}>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>NIM :</label>
                                                    <input
                                                        type="text"
                                                        name="nim"
                                                        className="form-control form-biodata"
                                                        disabled
                                                        value={this.state.formdata.nim}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Nama Lengkap<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <input
                                                        type="text"
                                                        name="nama"
                                                        className="form-control form-biodata"
                                                        value={this.state.formdata.nama}
                                                        onChange={this.onChangeInput}
                                                        required
                                                        style={{ textTransform: 'uppercase' }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Prodi :</label>
                                                    <input
                                                        type="text"
                                                        name="prodi"
                                                        className="form-control form-biodata"
                                                        disabled
                                                        value={this.state.formdata.prodi}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Dosen Wali :</label>
                                                    <input
                                                        type="text"
                                                        name="dosen_wali"
                                                        className="form-control form-biodata"
                                                        disabled
                                                        value={this.state.formdata.dosen_wali}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="TapS2">
                                <div className="tapbs2">
                                    <input type="checkbox" id="chck4" className="checkBox2" />
                                    <label className="tapbs-label2" htmlFor="chck4">Status Mahasiswa</label>
                                    <div className="tapbs-content2">
                                        <div className="row" style={{ padding: '10px 23px 10px 23px' }}>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Status Mahasiswa :</label>
                                                    <select name="status_mhs" className="form-control form-biodata"
                                                        disabled value={this.state.formdata.status_mhs}
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.statusMhs.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list.id_status_mahasiswa}>{list.status_keterangan}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Status Kelas :</label>
                                                    <select className="form-control form-biodata" name="status_kelas"
                                                        disabled value={this.state.formdata.status_kelas}
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.statusKelas.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list.id}>{list.jenis_kelas}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Jalur Mahasiswa :</label>
                                                    <select className="form-control form-biodata" name="jalur"
                                                        disabled value={this.state.formdata.jalur}>
                                                        <option value=''>- pilih -</option>
                                                        {
                                                            this.state.jalur.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list.id_jalur}>{list.nama_jalur}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Kategori Kelas :</label>
                                                    <select className="form-control form-biodata" name="kategori_kelas"
                                                        disabled value={this.state.formdata.kategori_kelas}
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.kategoriKelas.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list.id_subjalur}>{list.ket_subjalur}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Jalur Transfer :</label>
                                                    <select className="form-control form-biodata" name="jalur_transfer"
                                                        disabled value={this.state.formdata.jalur_transfer}
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.jalurTransfer.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list.id_gruptransfer}>{list.nama_gruptransfer}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="TapS2">
                                <div className="tapbs2">
                                    <input type="checkbox" id="chck5" className="checkBox2" />
                                    <label className="tapbs-label2" htmlFor="chck5">Data Diri Mahasiswa</label>
                                    <div className="tapbs-content2">
                                        <div className="row" style={{ padding: '10px 23px 10px 23px' }}>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Jenis Kelamin<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="gender" className="form-control form-biodata"
                                                        onChange={this.onChangeInput} value={this.state.formdata.gender}
                                                        required
                                                    >
                                                        <option value="">- pilih -</option>
                                                        <option value="1">Laki-Laki</option>
                                                        <option value="2">Perempuan</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Tempat Lahir<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <input type="text" className="form-control" name="tempat_lahir"
                                                        onChange={this.onChangeInput} value={this.state.formdata.tempat_lahir}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Tanggal Lahir<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <input type="date" className="form-control" name="tgl_lahir"
                                                        onChange={this.onChangeInput} value={this.state.formdata.tgl_lahir}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Kewarganegaraan<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="kewarganegaraan" onChange={this.onChangeWarga}
                                                        required
                                                        value={this.state.formdata.kewarganegaraan}
                                                        className="form-control">
                                                        <option value="">- pilih -</option>
                                                        <option value="WNI">WNI</option>
                                                        <option value="WNA">WNA</option>
                                                    </select>
                                                </div>
                                            </div>
                                            {
                                                this.state.isWNA ?
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>Nama Negara<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <input type="text" className="form-control" name="negara"
                                                                onChange={this.onChangeInput} value={this.state.formdata.negara}
                                                            />
                                                        </div>
                                                    </div>
                                                    : null
                                            }
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Agama<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="agama" className="form-control form-biodata"
                                                        onChange={this.onChangeInput} value={this.state.formdata.agama}
                                                        required
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.agama.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list}>{list}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Status Pernikahan<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="status_nikah" className="form-control form-biodata"
                                                        onChange={this.onChangeInput} value={this.state.formdata.status_nikah}
                                                        required
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.statusNikah.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list}>{list}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="TapS2">
                                <div className="tapbs2">
                                    <input type="checkbox" id="chck6" className="checkBox2" />
                                    <label className="tapbs-label2" htmlFor="chck6">Alamat Mahasiswa</label>
                                    <div className="tapbs-content2">
                                        <div className="row" style={{ padding: '10px 23px 10px 23px' }}>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Provinsi<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="provinsi" className="form-control form-biodata"
                                                        onChange={this.onChangeProv} value={this.state.formdata.provinsi}
                                                        required
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.provinsiList.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list.i}>{list.pname}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Kabupaten/Kota<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="kab" className="form-control form-biodata"
                                                        onChange={this.onChangeKota} value={this.state.formdata.kab}
                                                        required
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.kotaList.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list.cname}>{list.cname}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Jalan<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <textarea cols="30" rows="4" className="form-control" name="jalan"
                                                        onChange={this.onChangeInput} value={this.state.formdata.jalan}
                                                        required
                                                    ></textarea>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Dusun<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <input type="text" className="form-control" name="dusun"
                                                        onChange={this.onChangeInput} value={this.state.formdata.dusun}
                                                        required
                                                    ></input>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Kecamatan<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="kecamatan" className="form-control form-biodata"
                                                        onChange={this.onChangeInput} value={this.state.formdata.kecamatan}>
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.kecamatanList.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list.dname}>{list.dname}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Kelurahan/Desa<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <input type="text" className="form-control" name="kelurahan"
                                                        onChange={this.onChangeInput}
                                                        value={this.state.formdata.kelurahan}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>RT<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <input type="number" name="rt" className="form-control" onChange={this.onChangeInput}
                                                        value={this.state.formdata.rt}
                                                        required
                                                        onKeyUp={(e) => {
                                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3)
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>RW<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <input type="number" name="rw" className="form-control" onChange={this.onChangeInput}
                                                        value={this.state.formdata.rw}
                                                        required
                                                        onKeyUp={(e) => {
                                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3)
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Kode Pos :</label>
                                                    <input type="number" name="kdpos" className="form-control" onChange={this.onChangeInput}
                                                        value={this.state.formdata.kdpos}
                                                        required
                                                        onKeyUp={(e) => {
                                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 5)
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="TapS2">
                                <div className="tapbs2">
                                    <input type="checkbox" id="chck7" className="checkBox2" />
                                    <label className="tapbs-label2" htmlFor="chck7">Informasi Akun dan Lainnya</label>
                                    <div className="tapbs-content2">
                                        <div className="row" style={{ padding: '10px 23px 10px 23px' }}>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Nomor WhatsApp<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <input type="number" className="form-control" name="nowa"
                                                        onChange={this.onChangeInput}
                                                        value={this.state.formdata.nowa}
                                                        onKeyUp={formatPhone}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Email<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <input type="email" className="form-control" name="email"
                                                        onChange={this.onChangeInput}
                                                        value={this.state.formdata.email}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            {
                                                this.state.isWNA ?
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>ID Passport<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <input type="number" className="form-control" name="passport"
                                                                onChange={this.onChangeInput}
                                                                value={this.state.formdata.passport}
                                                            />
                                                        </div>
                                                    </div>
                                                    :
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>Nomor Induk Kependudukan (NIK)<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <input type="number" className="form-control" name="nik"
                                                                onChange={this.onChangeInput}
                                                                value={this.state.formdata.nik}
                                                            />
                                                        </div>
                                                    </div>
                                            }
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Nomor Induk Siswa Nasional (NISN)<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <input type="number" className="form-control" name="nisn"
                                                        onChange={this.onChangeInput}
                                                        value={this.state.formdata.nisn}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>NPWP :</label>
                                                    <input type="number" className="form-control" name="npwp"
                                                        onChange={this.onChangeInput}
                                                        value={this.state.formdata.npwp}
                                                        onInput={(e) => { e.target.value = e.target.value.slice(0, 16) }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Jenis Tinggal<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="jenis_tinggal"
                                                        className="form-control"
                                                        onChange={this.onChangeInput}
                                                        value={this.state.formdata.jenis_tinggal}
                                                        required
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.jenisTinggal.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list}>{list}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Alat Transportasi<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="alat_transport"
                                                        className="form-control"
                                                        onChange={this.onChangeInput}
                                                        value={this.state.formdata.alat_transport}
                                                        required
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.transportasi.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list}>{list}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Kode Virtual Account :</label>
                                                    <input type="number" className="form-control" name="kodeva"
                                                        disabled value={this.state.formdata.kodeva} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* end tab biodata  */}

                        {/* tab orang tua  */}
                        <div className="tabsCon" id="tab2box">
                            <div className="TapS2">
                                <div className="tapbs2">
                                    <input type="checkbox" id="chck8" className="checkBox2 openTab" />
                                    <label className="tapbs-label2" htmlFor="chck8">Data Ayah Mahasiswa</label>
                                    <div className="tapbs-content2">
                                        <div className="row" style={{ padding: '10px 23px 10px 23px' }}>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Nomor Induk Kependudukan (NIK) Ayah<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <input type="number" className="form-control" name="nikayah"
                                                        onChange={this.onChangeInput}
                                                        value={this.state.formdata.nikayah}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Nama Ayah<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <input type="text" className="form-control" name="namaayah"
                                                        onChange={this.onChangeInput}
                                                        value={this.state.formdata.namaayah}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Keterangan Hidup<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="keterangan_hidup_ayah"
                                                        className="form-control" onChange={this.onChangeInput}
                                                        value={this.state.formdata.keterangan_hidup_ayah}
                                                        required
                                                    >
                                                        <option value="">- pilih -</option>
                                                        <option value="Hidup">Hidup</option>
                                                        <option value="Meninggal">Meninggal</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Tanggal Lahir<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <input type="date" name="tgl_lahir_ayah" className="form-control"
                                                        onChange={this.onChangeInput}
                                                        value={this.state.formdata.tgl_lahir_ayah}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Pendidikan<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="pendidikan_ayah" onChange={this.onChangeInput}
                                                        value={this.state.formdata.pendidikan_ayah}
                                                        className="form-control"
                                                        required
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.pendidikan.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list}>{list}</option>
                                                                )
                                                            })
                                                        }
                                                        <option value="S3">S3</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Pekerjaan<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="pekerjaan_ayah"
                                                        className="form-control" onChange={this.onChangeInput}
                                                        value={this.state.formdata.pekerjaan_ayah}
                                                        required
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.pekerjaan.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list}>{list}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Penghasilan<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="penghasilan_ayah" onChange={this.onChangeInput}
                                                        className="form-control"
                                                        value={this.state.formdata.penghasilan_ayah}
                                                        required
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.penghasilan.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list}>{list}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>No. Telepon :</label>
                                                    <input type="number" name="notelp_ayah" className="form-control"
                                                        onChange={this.onChangeInput}
                                                        value={this.state.formdata.notelp_ayah}
                                                        onKeyUp={formatPhone}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="TapS2">
                                <div className="tapbs2">
                                    <input type="checkbox" id="chck9" className="checkBox2" />
                                    <label className="tapbs-label2" htmlFor="chck9">Data Ibu Mahasiswa</label>
                                    <div className="tapbs-content2">
                                        <div className="row" style={{ padding: '10px 23px 10px 23px' }}>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Nomor Induk Kependudukan (NIK) Ibu<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <input type="number" className="form-control" name="nik_ibu"
                                                        onChange={this.onChangeInput}
                                                        value={this.state.formdata.nik_ibu}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Nama Ibu<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <input type="text" className="form-control" name="nama_ibu"
                                                        onChange={this.onChangeInput}
                                                        value={this.state.formdata.nama_ibu}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Keterangan Hidup<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="keterangan_hidup_ibu"
                                                        className="form-control" onChange={this.onChangeInput}
                                                        value={this.state.formdata.keterangan_hidup_ibu}
                                                        required
                                                    >
                                                        <option value="">- pilih -</option>
                                                        <option value="hidup">Hidup</option>
                                                        <option value="meninggal">Meninggal</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Tanggal Lahir<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <input type="date" name="tgl_lahir_ibu" className="form-control"
                                                        onChange={this.onChangeInput}
                                                        value={this.state.formdata.tgl_lahir_ibu}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Pendidikan<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="pendidikan_ibu" onChange={this.onChangeInput}
                                                        value={this.state.formdata.pendidikan_ibu}
                                                        className="form-control"
                                                        required
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.pendidikan.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list}>{list}</option>
                                                                )
                                                            })
                                                        }
                                                        <option value="S3">S3</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Pekerjaan<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="pekerjaan_ibu"
                                                        className="form-control" onChange={this.onChangeInput}
                                                        value={this.state.formdata.pekerjaan_ibu}
                                                        required
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.pekerjaan.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list}>{list}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Penghasilan<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="penghasilan_ibu" onChange={this.onChangeInput}
                                                        className="form-control"
                                                        value={this.state.formdata.penghasilan_ibu}
                                                        required
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.penghasilan.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list}>{list}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>No. Telepon :</label>
                                                    <input type="number" name="notelp_ibu" className="form-control"
                                                        onChange={this.onChangeInput}
                                                        value={this.state.formdata.notelp_ibu}
                                                        onKeyUp={formatPhone}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="TapS2">
                                <div className="tapbs2">
                                    <input type="checkbox" id="chck10" className="checkBox2" />
                                    <label className="tapbs-label2" htmlFor="chck10">Data Wali Mahasiswa</label>
                                    <div className="tapbs-content2">
                                        <div className="row" style={{ padding: '10px 23px 10px 23px' }}>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Nama Wali<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <input type="text" name="nama_wali" className="form-control"
                                                        value={this.state.formdata.nama_wali}
                                                        onChange={this.onChangeInput}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Tanggal Lahir<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <input type="date" name="tgllahirwali" className="form-control"
                                                        value={this.state.formdata.tgllahirwali}
                                                        onChange={this.onChangeInput}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Pendidikan<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="pendidikan_wali" onChange={this.onChangeInput}
                                                        value={this.state.formdata.pendidikan_wali}
                                                        className="form-control"
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.pendidikan.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list}>{list}</option>
                                                                )
                                                            })
                                                        }
                                                        <option value="S3">S3</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Pekerjaan<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="pekerjaan_wali"
                                                        className="form-control" onChange={this.onChangeInput}
                                                        value={this.state.formdata.pekerjaan_wali}
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.pekerjaan.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list}>{list}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Penghasilan<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                    <select name="penghasilan_wali" onChange={this.onChangeInput}
                                                        className="form-control"
                                                        value={this.state.formdata.penghasilan_wali}
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.penghasilan.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list}>{list}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>No. Telepon :</label>
                                                    <input type="number" name="notelpwali" className="form-control"
                                                        onChange={this.onChangeInput}
                                                        value={this.state.formdata.notelpwali}
                                                        onKeyUp={formatPhone}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* end tab orang tua  */}

                        {/* tab abk  */}
                        <div className="tabsCon" id="tab3box">
                            <div className="TapS2">
                                <div className="tapbs2">
                                    <input type="checkbox" id="chck11" className="checkBox2 openTab" />
                                    <label className="tapbs-label2" htmlFor="chck11">Mahasiswa</label>
                                    <div className="tapbs-content2">
                                        <div style={{ padding: '5px 23px 30px 23px' }}>
                                            <div className="table-responsive">
                                                <table className="kebutuhanMhs" align="center" width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td valign="top">
                                                                {
                                                                    optionKebutuhan_1.map((v, index) => (
                                                                        <Fragment key={index}>
                                                                            <input type="checkbox" name="keb_mhs" value={v.value} onChange={this.onChangeKhusus} />&nbsp;{v.name}<br />
                                                                        </Fragment>
                                                                    ))
                                                                }
                                                            </td>
                                                            <td valign="top">
                                                                {
                                                                    optionKebutuhan_2.map((v, index) => (
                                                                        <Fragment key={index}>
                                                                            <input type="checkbox" name="keb_mhs" value={v.value} onChange={this.onChangeKhusus} />&nbsp;{v.name}<br />
                                                                        </Fragment>
                                                                    ))
                                                                }
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="TapS2">
                                <div className="tapbs2">
                                    <input type="checkbox" id="chck12" className="checkBox2 openTab" />
                                    <label className="tapbs-label2" htmlFor="chck12">Ayah</label>
                                    <div className="tapbs-content2">
                                        <div style={{ padding: '5px 23px 30px 23px' }}>
                                            <div className="table-responsive">
                                                <table className="kebutuhanAyah" align="center" width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td valign="top">
                                                                {
                                                                    optionKebutuhan_1.map((v, index) => (
                                                                        <Fragment key={index}>
                                                                            <input type="checkbox" name="keb_ayah" value={v.value} onChange={this.onChangeKhusus} />&nbsp;{v.name}<br />
                                                                        </Fragment>
                                                                    ))
                                                                }
                                                            </td>
                                                            <td valign="top">
                                                                {
                                                                    optionKebutuhan_2.map((v, index) => (
                                                                        <Fragment key={index}>
                                                                            <input type="checkbox" name="keb_ayah" value={v.value} onChange={this.onChangeKhusus} />&nbsp;{v.name}<br />
                                                                        </Fragment>
                                                                    ))
                                                                }
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="TapS2">
                                <div className="tapbs2">
                                    <input type="checkbox" id="chck13" className="checkBox2 openTab" />
                                    <label className="tapbs-label2" htmlFor="chck13">Ibu</label>
                                    <div className="tapbs-content2">
                                        <div style={{ padding: '5px 23px 30px 23px' }}>
                                            <div className="table-responsive">
                                                <table className="kebutuhanIbu" align="center" width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td valign="top">
                                                                {
                                                                    optionKebutuhan_1.map((v, index) => (
                                                                        <Fragment key={index}>
                                                                            <input type="checkbox" name="keb_ibu" value={v.value} onChange={this.onChangeKhusus} />&nbsp;{v.name}<br />
                                                                        </Fragment>
                                                                    ))
                                                                }
                                                            </td>
                                                            <td valign="top">
                                                                {
                                                                    optionKebutuhan_2.map((v, index) => (
                                                                        <Fragment key={index}>
                                                                            <input type="checkbox" name="keb_ibu" value={v.value} onChange={this.onChangeKhusus} />&nbsp;{v.name}<br />
                                                                        </Fragment>
                                                                    ))
                                                                }
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* end tab abk  */}

                        {/* tab riwayat transfer  */}
                        <div className="tabsCon" id="tab4box">
                            <div className="TapS2">
                                <div className="tapbs2">
                                    <input type="checkbox" id="chck14" className="checkBox2 openTab" />
                                    <label className="tapbs-label2" htmlFor="chck14">Riwayat Transfer</label>
                                    <div className="tapbs-content2">
                                        <div className="row" style={{ padding: '10px 23px 10px 23px' }}>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>NIM Asal :</label>
                                                    <input type="text" className="form-control" name="nim_asal_tf"
                                                        onChange={this.onChangeInput}
                                                        value={this.state.formdata.nim_asal_tf}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Tanggal Lulus :</label>
                                                    <input type="date" className="form-control" name="thnlulus_tf"
                                                        onChange={this.onChangeInput}
                                                        value={this.state.formdata.thnlulus_tf}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Jenjang Pendidikan Asal :</label>
                                                    <select className="form-control" name="jenjang_asal_tf"
                                                        onChange={this.onChangeInput}
                                                        value={this.state.formdata.jenjang_asal_tf}
                                                    >
                                                        <option value="">- pilih -</option>
                                                        {
                                                            this.state.jenjang_pendidikan.map((list, i) => {
                                                                return (
                                                                    <option key={i} value={list.value}>{list.nama}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Asal Perguruan Tinggi :</label>
                                                    <select name="perguruan_tinggi_tf"
                                                        className="form-control"
                                                        onChange={this.onChangeJenisTF}
                                                        value={this.state.formdata.perguruan_tinggi_tf}
                                                    >
                                                        <option value="">- pilih -</option>
                                                        <option value="0">Institut Asia Malang</option>
                                                        <option value="1">Perguruan Tinggi lain</option>
                                                    </select>
                                                </div>
                                            </div>
                                            {
                                                this.state.formdata.perguruan_tinggi_tf == 0 ?
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Nama Program Studi Asal :</label>
                                                            <select className="form-control" name="jurusan_asal_tf"
                                                                onChange={this.onChangeInput}
                                                                value={this.state.formdata.jurusan_asal_tf}
                                                            >
                                                                <option value="">- pilih -</option>
                                                                {
                                                                    this.state.jurusan.map((list, i) => {
                                                                        return (
                                                                            <option key={i} value={list.nama_jurusan}>{list.nama_jurusan}</option>
                                                                        )
                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                    :
                                                    <>
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label>Nama Perguruan Tinggi :</label>
                                                                <input type="text" name="nama_perguruan_tinggi_asal" className="form-control"
                                                                    onChange={this.onChangeInput}
                                                                    value={this.state.formdata.nama_perguruan_tinggi_asal}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label>Nama Program Studi Asal :</label>
                                                                <input type="text" name="jurusan_asal_tf" className="form-control"
                                                                    onChange={this.onChangeInput}
                                                                    value={this.state.formdata.jurusan_asal_tf}
                                                                />
                                                            </div>
                                                        </div>
                                                    </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* end tab riwayat transfer  */}

                        {/* tab unggah berkas  */}
                        <div className="tabsCon" id="tab5box">
                            <div className="TapS2">
                                <div className="tapbs2">
                                    <input type="checkbox" id="chck14" className="checkBox2 openTab" />
                                    <label className="tapbs-label2" htmlFor="chck14">Unggah Berkas</label>
                                    <div className="tapbs-content2">
                                        <div className="row" style={{ padding: '10px 23px 10px 23px' }}>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Untuk Semua Mahasiswa :</label>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>KTP :</label>
                                                    <p id='loader-form-ktp' className='sembunyi'>Mengunggah Berkas...&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i></p>
                                                    <div className="row" id='berkas-form-ktp'>
                                                        {
                                                            this.state.formdata.berkas.ktp == undefined ?
                                                                <div className="col-md-12">
                                                                    <input
                                                                        type="file"
                                                                        name="ktp"
                                                                        id="form-ktp"
                                                                        onChange={this.onChangeBerkas}
                                                                        className="form-control" />
                                                                </div>
                                                                :
                                                                <>
                                                                    <div className="col-md-9 mb-2">
                                                                        <input
                                                                            type="file"
                                                                            name="ktp"
                                                                            id="form-ktp"
                                                                            onChange={this.onChangeBerkas}
                                                                            className="form-control sembunyi" />
                                                                        <button className="btn btn-info btn-block" type="button" id="btn-form-ktp"
                                                                            onClick={() => this.getDownload(this.state.formdata.berkas.ktp, this.state.formdata.nim, "ktp")}>
                                                                            <i className="fa fa-download"></i>&nbsp;&nbsp;Unduh {this.state.formdata.nim}-ktp
                                                                        </button>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <button className="btn btn-light btn-block" type="button" onClick={() => this.handleUpload("form-ktp")}>
                                                                            <div id="toogle-form-ktp"><i className="fa fa-upload"></i>&nbsp;&nbsp;Ganti File</div>
                                                                            <div id="toogle2-form-ktp" className='sembunyi'><i className="fa fa-times"></i>&nbsp;&nbsp;Batal</div>
                                                                        </button>
                                                                    </div>
                                                                </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Kartu Keluarga :</label>
                                                    <p id='loader-form-kk' className='sembunyi'>Mengunggah Berkas...&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i></p>
                                                    <div className="row" id='berkas-form-kk'>
                                                        {
                                                            this.state.formdata.berkas.kk == undefined ?
                                                                <div className="col-md-12">
                                                                    <input
                                                                        type="file"
                                                                        name="kk"
                                                                        id="form-kk"
                                                                        onChange={this.onChangeBerkas}
                                                                        className="form-control" />
                                                                </div>
                                                                :
                                                                <>
                                                                    <div className="col-md-9 mb-2">
                                                                        <input
                                                                            type="file"
                                                                            name="kk"
                                                                            id="form-kk"
                                                                            onChange={this.onChangeBerkas}
                                                                            className="form-control sembunyi" />
                                                                        <button className="btn btn-info btn-block" type="button" id="btn-form-kk"
                                                                            onClick={() => this.getDownload(this.state.formdata.berkas.kk, this.state.formdata.nim, "kk")}>
                                                                            <i className="fa fa-download"></i>&nbsp;&nbsp;Unduh {this.state.formdata.nim}-kk
                                                                        </button>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <button className="btn btn-light btn-block" type="button" onClick={() => this.handleUpload("form-kk")}>
                                                                            <div id="toogle-form-kk"><i className="fa fa-upload"></i>&nbsp;&nbsp;Ganti File</div>
                                                                            <div id="toogle2-form-kk" className='sembunyi'><i className="fa fa-times"></i>&nbsp;&nbsp;Batal</div>
                                                                        </button>
                                                                    </div>
                                                                </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Ijazah :</label>
                                                    <p id='loader-form-ijazah-sma' className='sembunyi'>Mengunggah Berkas...&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i></p>
                                                    <div className="row" id='berkas-form-ijazah-sma'>
                                                        {
                                                            this.state.formdata.berkas.ijazah == undefined || this.state.formdata.berkas.ijazah.length == 0 ?
                                                                <div className="col-md-12">
                                                                    <input
                                                                        type="file"
                                                                        name="ijazah"
                                                                        id="form-ijazah-sma"
                                                                        onChange={this.onChangeBerkas}
                                                                        className="form-control" />
                                                                </div>
                                                                :
                                                                <>
                                                                    <div className="col-md-9 mb-2">
                                                                        <input
                                                                            type="file"
                                                                            name="ijazah"
                                                                            id="form-ijazah-sma"
                                                                            onChange={this.onChangeBerkas}
                                                                            className="form-control sembunyi" />
                                                                        <button className="btn btn-info btn-block" type="button" id="btn-form-ijazah-sma"
                                                                            onClick={() => this.getDownload(this.state.formdata.berkas.ijazah, this.state.formdata.nim, "ijazah")}>
                                                                            <i className="fa fa-download"></i>&nbsp;&nbsp;Unduh {this.state.formdata.nim}-ijazah
                                                                        </button>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <button className="btn btn-light btn-block" type="button" onClick={() => this.handleUpload("form-ijazah-sma")}>
                                                                            <div id="toogle-form-ijazah-sma"><i className="fa fa-upload"></i>&nbsp;&nbsp;Ganti File</div>
                                                                            <div id="toogle2-form-ijazah-sma" className='sembunyi'><i className="fa fa-times"></i>&nbsp;&nbsp;Batal</div>
                                                                        </button>
                                                                    </div>
                                                                </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Tambahan Untuk Mahasiswa Transfer :</label>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Ijazah D1/D2/D3/D4 :</label>
                                                    <p id='loader-form-ijazah-transfer' className='sembunyi'>Mengunggah Berkas...&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i></p>
                                                    <div className="row" id='berkas-form-ijazah-transfer'>
                                                        {
                                                            this.state.formdata.berkas.ijazah_transfer == undefined || this.state.formdata.berkas.ijazah_transfer.length == 0 ?
                                                                <div className="col-md-12">
                                                                    <input
                                                                        type="file"
                                                                        name="ijazah_transfer"
                                                                        id="form-ijazah-transfer"
                                                                        onChange={this.onChangeBerkas}
                                                                        className="form-control" />
                                                                </div>
                                                                :
                                                                <>
                                                                    <div className="col-md-9 mb-2">
                                                                        <input
                                                                            type="file"
                                                                            name="ijazah_transfer"
                                                                            id="form-ijazah-transfer"
                                                                            onChange={this.onChangeBerkas}
                                                                            className="form-control sembunyi" />
                                                                        <button className="btn btn-info btn-block" type="button" id="btn-form-ijazah-transfer"
                                                                            onClick={() => this.getDownload(this.state.formdata.berkas.ijazah_transfer, this.state.formdata.nim, "ijazah_transfer")}>
                                                                            <i className="fa fa-download"></i>&nbsp;&nbsp;Unduh {this.state.formdata.nim}-ijazah-transfer
                                                                        </button>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <button className="btn btn-light btn-block" type="button" onClick={() => this.handleUpload("form-ijazah-transfer")}>
                                                                            <div id="toogle-form-ijazah-transfer"><i className="fa fa-upload"></i>&nbsp;&nbsp;Ganti File</div>
                                                                            <div id="toogle2-form-ijazah-transfer" className='sembunyi'><i className="fa fa-times"></i>&nbsp;&nbsp;Batal</div>
                                                                        </button>
                                                                    </div>
                                                                </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Transkrip :</label>
                                                    <p id='loader-form-transkrip' className='sembunyi'>Mengunggah Berkas...&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i></p>
                                                    <div className="row" id='berkas-form-transkrip'>
                                                        {
                                                            this.state.formdata.berkas.transkrip == undefined ?
                                                                <div className="col-md-12">
                                                                    <input
                                                                        type="file"
                                                                        name="transkrip"
                                                                        id="form-transkrip"
                                                                        onChange={this.onChangeBerkas}
                                                                        className="form-control" />
                                                                </div>
                                                                :
                                                                <>
                                                                    <div className="col-md-9 mb-2">
                                                                        <input
                                                                            type="file"
                                                                            name="transkrip"
                                                                            id="form-transkrip"
                                                                            onChange={this.onChangeBerkas}
                                                                            className="form-control sembunyi" />
                                                                        <button className="btn btn-info btn-block" type="button" id="btn-form-transkrip"
                                                                            onClick={() => this.getDownload(this.state.formdata.berkas.transkrip, this.state.formdata.nim, "transkrip")}>
                                                                            <i className="fa fa-download"></i>&nbsp;&nbsp;Unduh {this.state.formdata.nim}-transkrip
                                                                        </button>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <button className="btn btn-light btn-block" type="button" onClick={() => this.handleUpload("form-transkrip")}>
                                                                            <div id="toogle-form-transkrip"><i className="fa fa-upload"></i>&nbsp;&nbsp;Ganti File</div>
                                                                            <div id="toogle2-form-transkrip" className='sembunyi'><i className="fa fa-times"></i>&nbsp;&nbsp;Batal</div>
                                                                        </button>
                                                                    </div>
                                                                </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Surat Keterangan Pindah :</label>
                                                    <p id='loader-form-skp' className='sembunyi'>Mengunggah Berkas...&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i></p>
                                                    <div className="row" id='berkas-form-skp'>
                                                        {
                                                            this.state.formdata.berkas.skp == undefined ?
                                                                <div className="col-md-12">
                                                                    <input
                                                                        type="file"
                                                                        name="skp"
                                                                        id="form-skp"
                                                                        onChange={this.onChangeBerkas}
                                                                        className="form-control" />
                                                                </div>
                                                                :
                                                                <>
                                                                    <div className="col-md-9 mb-2">
                                                                        <input
                                                                            type="file"
                                                                            name="skp"
                                                                            id="form-skp"
                                                                            onChange={this.onChangeBerkas}
                                                                            className="form-control sembunyi" />
                                                                        <button className="btn btn-info btn-block" type="button" id="btn-form-skp"
                                                                            onClick={() => this.getDownload(this.state.formdata.berkas.skp, this.state.formdata.nim, "skp")}>
                                                                            <i className="fa fa-download"></i>&nbsp;&nbsp;Unduh {this.state.formdata.nim}-skp
                                                                        </button>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <button className="btn btn-light btn-block" type="button" onClick={() => this.handleUpload("form-skp")}>
                                                                            <div id="toogle-form-skp"><i className="fa fa-upload"></i>&nbsp;&nbsp;Ganti File</div>
                                                                            <div id="toogle2-form-skp" className='sembunyi'><i className="fa fa-times"></i>&nbsp;&nbsp;Batal</div>
                                                                        </button>
                                                                    </div>
                                                                </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* end tab unggah berkas  */}
                    </div>
                </div>
            </Fragment >
        );
    }
}

export default Biodata;
